import React, { useState } from 'react';
import BalanceGridRow from '../types';
import { Button, Icon, Input, Message, Popup } from 'semantic-ui-react';
import { BalancesGridContext } from '../Balances/BalancesGrid';
import { GridApi } from 'ag-grid-community';
import { LockedState } from 'ts/models/Account.model';

type Props = {
  data: BalanceGridRow;
  context: BalancesGridContext;
  api: GridApi;
};

export const LOCKED_STATE_VAUES: LockedState[] = ['locked', 'unlocked'];

const getUpdateObject = (prev: LockedState, lockedComment: string) => {
  return {
    lockedComment,
    lockedState: prev === 'locked' ? 'unlocked' : 'locked',
  };
};

const LockRenderer = ({ data, api, context }: Props) => {
  const locked = data?.lockedState === 'locked';
  const [comment, setComment] = useState(data?.lockedComment || '');
  return (
    <Popup
      disabled={context?.isReadOnlyRole}
      trigger={
        <Icon
          name={locked ? 'lock' : 'unlock alternate'}
          color={locked ? 'red' : 'black'}
        />
      }
      on="click"
      content={
        <>
          <Message info>
            <Message.Header>Comments:</Message.Header>
            <p>{data?.lockedComment}</p>
          </Message>
          <div className="flex-row">
            <Input
              name="comment"
              placeholder="Enter Comment"
              required
              value={comment}
              onChange={(e, { value }) => {
                setComment(value);
              }}
            />
            <Button
              labelPosition="right"
              color={locked ? 'green' : 'red'}
              icon="flag"
              content={locked ? 'Unlock' : 'Lock'}
              onClick={() =>
                context?.updateAccount(api, {
                  accountId: data?.accountId,
                  update: getUpdateObject(data?.lockedState, comment),
                })
              }
            />
          </div>
        </>
      }
    />
  );
};

export default LockRenderer;
